var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.loading ? _c('v-skeleton-loader', {
    staticClass: "tree-skeleton",
    attrs: {
      "type": "heading"
    }
  }) : _vm.fleetTree.length ? _c('v-treeview', {
    attrs: {
      "items": _vm.fleetTree,
      "item-key": "id",
      "item-text": "name",
      "open": _vm.openNodes,
      "activatable": "",
      "selectable": "",
      "multiple": "",
      "selection-type": "independent",
      "open-on-click": ""
    },
    on: {
      "update:open": function updateOpen($event) {
        _vm.openNodes = $event;
      }
    },
    model: {
      value: _vm.selectedFleetIds,
      callback: function callback($$v) {
        _vm.selectedFleetIds = $$v;
      },
      expression: "selectedFleetIds"
    }
  }) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }